var __default__ = {root:'m_2ce0de02'};
export default __default__;